<template>
  <date-picker
    :value="valueMoment"
    :config="date_options"
    @dp-change="updateDate"
  />
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue-bootstrap-datetimepicker';

export default {
  components: {
    DatePicker,
  },
  props: {
    value: String || Object,
    end: Boolean,
    start: Boolean,
  },
  computed: {
    valueMoment() {
      return moment(this.value);
    },
  },
  data() {
    return {
      date_options: {
        format: 'L',
        locale: moment.locale(),
        icons: {
          time: 'material-icons access_time',
          date: 'material-icons date_range',
          up: 'material-icons keyboard_arrow_up',
          down: 'material-icons keyboard_arrow_down',
          previous: 'material-icons keyboard_arrow_left',
          next: 'material-icons keyboard_arrow_right',
          today: 'material-icons today',
          clear: 'material-icons clear',
          close: 'material-icons close',
        },
      },
    };
  },
  methods: {
    updateDate({ date }) {
      let result = null;
      if (date) {
        result = date.toISOString(true);
        if (this.end) {
          result = date.endOf('day').toISOString(true);
        }
        if (this.start) {
          result = date.startOf('day').toISOString(true);
        }
      }
      this.$emit('input', result);
    },
  },
};
</script>

<style lang="scss">
@import '../scss/_datetimepicker.scss';
</style>
